import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuStorageComing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4695 15.04C11.5395 15.11 11.6195 15.16 11.7095 15.2C11.7995 15.24 11.8995 15.26 11.9995 15.26C12.0995 15.26 12.1895 15.24 12.2895 15.2C12.3795 15.16 12.4595 15.11 12.5295 15.04L15.5295 12.04C15.8195 11.75 15.8195 11.27 15.5295 10.98C15.2395 10.69 14.7595 10.69 14.4695 10.98L12.7495 12.7V6.51001C12.7495 6.10001 12.4095 5.76001 11.9995 5.76001C11.5895 5.76001 11.2495 6.10001 11.2495 6.51001V12.7L9.52945 10.98C9.23945 10.69 8.75945 10.69 8.46945 10.98C8.17945 11.27 8.17945 11.75 8.46945 12.04L11.4695 15.04Z",
			fill: "#FFFFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7097 16.28C18.5797 15.89 18.1597 15.68 17.7597 15.81C14.0397 17.05 9.9497 17.05 6.2297 15.81C5.8397 15.68 5.40969 15.89 5.27969 16.28C5.14969 16.67 5.35969 17.1 5.74969 17.23C7.75969 17.9 9.86969 18.24 11.9897 18.24C14.1097 18.24 16.2197 17.9 18.2297 17.23C18.6297 17.09 18.8397 16.67 18.7097 16.28Z",
			fill: "#FFFFFF"
		})
	]
});
export default SvgMenuStorageComing;
